var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var AddAddress = /** @class */ (function (_super) {
    __extends(AddAddress, _super);
    function AddAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledDataSource = ["IMPORT", "INTERFACE"];
        _this.model = {};
        _this.rules = {};
        return _this;
    }
    AddAddress.prototype.emitClose = function () {
        var form = this.$refs.form;
        form.resetFields();
    };
    AddAddress.prototype.created = function () {
        this.model = {
            contName: "",
            detail: "",
            dataSource: "",
            caseId: "",
            relation: "",
            addressType: "",
            addressStatus: "",
            areaIds: [],
            get areaId() {
                if (this.areaIds.length) {
                    return this.areaIds[this.areaIds.length - 1];
                }
                return "";
            }
        };
        this.rules = {
            contName: { required: true, message: "请输入联系人姓名" },
            dataSource: { required: true, message: "请选择案件来源" },
            relation: { required: true, message: "请选择客户关系" },
            areaIds: [{ required: true, message: "请选择地址" }],
            detail: [{ required: true, message: "请输入详细地址" }],
            addressStatus: [{ required: true, message: "请选择地址状态" }],
            addressType: [{ required: true, message: "请选择地址类型" }]
        };
    };
    AddAddress.prototype.submit = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (v) {
            if (!v)
                return;
            _this.model.caseId = _this.caseId;
            _this.caseOperatorPageService
                .repairPersonalContact(_this.model)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                form.resetFields();
                _this.emitClose();
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], AddAddress.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddAddress.prototype, "caseId", void 0);
    __decorate([
        Emit("close")
    ], AddAddress.prototype, "emitClose", null);
    AddAddress = __decorate([
        Component({
            components: {}
        })
    ], AddAddress);
    return AddAddress;
}(Vue));
export default AddAddress;
